import type { ContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import { TFunction } from 'i18next'
import { ContentTypeLabel } from './ContentTypeLabel'
import { ReactComponent as PlayIcon } from '@obeta/assets/icon/play.svg'
import { ReactComponent as ThreeDRotation } from '@obeta/assets/icon/designsystem/3d_rotation.svg'

export const getItemUrl = (item: ContentItem) => {
  if (item.contentType === 'oxomi3DImage') return item.preview
  if (item.contentType === 'video') return item.previewUrl

  return item.url
}

export const checkIsVideo = (stripeItem: ContentItem) => stripeItem.contentType === 'video'

export const renderLabel = (item: ContentItem, t?: TFunction, withLabel = false) => {
  if (checkIsVideo(item)) {
    return <ContentTypeLabel icon={PlayIcon} text={withLabel && t ? t('COMMON.VIDEO') : ''} />
  }

  if (checkIs3DImage(item)) {
    return (
      <ContentTypeLabel
        icon={ThreeDRotation}
        text={withLabel && t ? t('COMPONENTS.MEDIA_GALLERY.LABELS.THREE_D_IMAGE_VIEW') : ''}
      />
    )
  }

  return null
}

export const checkIs3DImage = (item: ContentItem) => item.contentType === 'oxomi3DImage'
